import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const MrPiggyPage = ({ language, setLanguage, t }) => {
  const targetDate = new Date('2025-08-08T00:00:00');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!t) return <div className="container">Error: Translations not loaded</div>;

  return (
    <div className="app-page-container">
      <LanguageSwitcher language={language} setLanguage={setLanguage} />
      
      <Link to="/" className="back-btn">
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        {t.back || 'Back'}
      </Link>

      {/* Hero Section */}
      <div className="app-hero">
        <div className="app-hero-content">
          <div className="app-icon-section">
            <img
              src="/images/piggy.png"
              alt="Mr Piggy"
              className="app-hero-icon"
              onError={(e) => { e.target.src = '/images/fallback.png'; }}
            />
            <div className="app-info">
              <h1 className="app-title">{t.mrPiggyTitle || 'Mr Piggy'}</h1>
              <p className="app-subtitle coming-soon-badge">{t.mrPiggyComingSoon || 'Coming Soon!'}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Countdown Section */}
      <div className="countdown-hero">
        <div className="countdown-content">
          <h2 className="countdown-title">{t.countdownLabel || 'Launching in'}</h2>
          <div className="countdown-display">
            <div className="countdown-block days">
              <div className="countdown-circle">
                <span className="countdown-number">{timeLeft.days}</span>
              </div>
              <span className="countdown-label">{t.days || 'Days'}</span>
            </div>
            <div className="countdown-separator">:</div>
            <div className="countdown-block hours">
              <div className="countdown-circle">
                <span className="countdown-number">{timeLeft.hours}</span>
              </div>
              <span className="countdown-label">{t.hours || 'Hours'}</span>
            </div>
            <div className="countdown-separator">:</div>
            <div className="countdown-block minutes">
              <div className="countdown-circle">
                <span className="countdown-number">{timeLeft.minutes}</span>
              </div>
              <span className="countdown-label">{t.minutes || 'Minutes'}</span>
            </div>
            <div className="countdown-separator">:</div>
            <div className="countdown-block seconds">
              <div className="countdown-circle">
                <span className="countdown-number">{timeLeft.seconds}</span>
              </div>
              <span className="countdown-label">{t.seconds || 'Seconds'}</span>
            </div>
          </div>
        </div>
        
        {/* Animated Background */}
        <div className="countdown-bg">
          <div className="floating-coin coin-1">🪙</div>
          <div className="floating-coin coin-2">💰</div>
          <div className="floating-coin coin-3">🪙</div>
          <div className="floating-coin coin-4">💎</div>
          <div className="floating-coin coin-5">🪙</div>
        </div>
      </div>

      {/* Coming Soon Info */}
      <div className="coming-soon-section">
        <div className="coming-soon-content">
          <h3>Get ready for the ultimate savings app!</h3>
          <p>Mr Piggy will help you save money, track expenses, and reach your financial goals with gamified challenges and smart insights.</p>
          
          <div className="feature-preview">
            <div className="preview-card">
              <div className="preview-icon">💰</div>
              <h4>Smart Savings</h4>
              <p>Automated saving rules</p>
            </div>
            <div className="preview-card">
              <div className="preview-icon">📊</div>
              <h4>Expense Tracking</h4>
              <p>Visual spending insights</p>
            </div>
            <div className="preview-card">
              <div className="preview-icon">🎯</div>
              <h4>Savings Goals</h4>
              <p>Achieve your dreams</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/">{t.ourApps || 'Home'}</Link>
            <Link to="/quitsnus">{t.quitSnusTitle || 'QuitSnus'}</Link>
          </div>
          <div className="footer-legal">
            <Link to="/mrpiggy-privacy">{t.privacyPolicy || 'Privacy Policy'}</Link>
            <Link to="/mrpiggy-terms">{t.termsOfUse || 'Terms of Service'}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MrPiggyPage;